module.exports = __webpack_public_path__ + "01cc50615ee3903da9a8a08cf437203e.png";